import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterLabel} from "./label.js";

export class FilterCheckbox extends AbstractFilterComponent {

	static selector = '.js-filter-checkbox';

	label;

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.bindEvents();
	}

	bindEvents() {
		let self = this;
		let input = self.node;

		input.addEventListener('change', function () {
			self.componentStateChanged();
		});
	}

	setCheckedState(state, dispatchEvent = true) {
		let self = this;

		self.node.checked = state;
		self.node.indeterminate = false;

		if (dispatchEvent) {
			self.node.dispatchEvent(new CustomEvent('change'));
		}
	}

	setIndeterminateState(state, dispatchEvent = true) {
		let self = this;

		self.node.indeterminate = state;
		self.node.checked = false;

		if (dispatchEvent) {
			self.node.dispatchEvent(new CustomEvent('change'));
		}
	}

	isChecked() {
		let self = this;

		return self.node.checked;
	}

	getLabel() {
		let self = this;

		if (! self.node.checked) {
			return;
		}

		if (self.label) {
			return self.label;
		}

		self.label = new FilterLabel(self, self.node.dataset.label);
		return self.label;
	}

	getName() {
		let self = this;
		return self.node.name;
	}

	getValue() {
		let self = this;
		return self.node.value;
	}

	labelDismissed() {
		let self = this;
		self.filter.setForceUpdateMode();

		self.node.checked = false;
		self.node.dispatchEvent(new CustomEvent('change'));
	}
}
